// Minimal browser-safe shim for SvelteKit's $app/state.
// Only meant to keep the widget build from failing if some shared code imports it.

const safeUrl = () => {
	try {
		return new URL(globalThis.location?.href ?? 'http://localhost/')
	} catch {
		return new URL('http://localhost/')
	}
}

// Shape is "good enough" for typical usages like page.url/searchParams.
export const page: any = {
	url: safeUrl(),
	params: {},
	route: { id: null },
	status: 200,
	error: null,
	data: {},
	form: null,
	state: {}
}

export const navigating: any = null
export const updated: any = false
